import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-session-expired-modal',
  templateUrl: './session-expired-modal.page.html',
  styleUrls: ['./session-expired-modal.page.scss'],
})
export class SessionExpiredModalPage {
  @Input() message = '';
  @Input() onConfirm: () => void = () => {};

  constructor(private modalController: ModalController) {}

  async dismissAndContinue() {
    await this.modalController.dismiss();
    this.onConfirm();
  }
}
